import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ItemTable from './ItemTable';
import TotalSection from './TotalSection';
import '../../CSS/Global.css';
import '../Equipments/ProductFormPage.css';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
import Loader from '../Loader';
import { describeDeliveryOutcome } from '../../utils/describeDeliveryOutcome';

const TERMS_OPTIONS = [
  { value: '', label: 'Select an option' },
  { value: '15-net', label: '15 Net' },
  { value: '30-net', label: '30 Net' },
  { value: '45-net', label: '45 Net' },
  { value: '60-net', label: '60 Net' },
  { value: 'end-month', label: 'Due end of the month' },
  { value: 'next-month', label: 'Due end of next month' },
  { value: 'custom', label: 'Custom' },
];

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

/** One toast after create/update — includes email / WhatsApp / pay-link outcome when published. */
function showInvoiceSubmitToast({ dpStatus, isEditing, result, isQuoteMode }) {
  if (dpStatus === "Draft") {
    toast.success(isQuoteMode ? "Quote draft saved successfully!" : "Invoice draft saved successfully!");
    return;
  }

  const docLabel = isQuoteMode ? "Quote" : "Invoice";
  const base = isEditing ? `${docLabel} updated successfully.` : `${docLabel} submitted successfully.`;
  const deliveryParts = describeDeliveryOutcome(result);

  if (deliveryParts.length === 0) {
    if (result?.pay_url) {
      toast.success(`${base} Pay link is ready for the customer.`, { autoClose: 5000 });
    } else {
      toast.success(base, { autoClose: 5000 });
    }
    return;
  }

  const hasError = deliveryParts.some(
    (p) => p.includes("failed") || p.includes("SMTP not configured")
  );
  const hasWarning = deliveryParts.some((p) => p.includes("skipped"));
  const message = `${base} ${deliveryParts.join("; ")}.`;

  if (hasError) toast.error(message, { autoClose: 8000 });
  else if (hasWarning) toast.warning(message, { autoClose: 8000 });
  else toast.success(message, { autoClose: 5000 });
}

const NewInvoice = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const { id: routeEditId } = useParams();
  const [routeInvoice, setRouteInvoice] = useState(null);
  const [loadingRouteInvoice, setLoadingRouteInvoice] = useState(false);
  const editInvoice = location.state?.invoice ?? routeInvoice;
  const isEditByRoute = location.pathname.includes("/edit-invoice/");
  const isQuoteFromDoc = ["quote", "proforma"].includes(
    String(editInvoice?.document_type || "").toLowerCase()
  );
  const isQuoteMode =
    location.pathname.includes("new-quote") || isQuoteFromDoc;
  const [modalOpen, setModalOpen] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [newSalesPerson, setNewSalesPerson] = useState({ name: '', email: '' });
  const [invoiceNumberNumeric, setInvoiceNumberNumeric] = useState('');
  const invoicePrefix = isQuoteMode ? "QUO" : "INVE";
  const [invoiceNumberError, setInvoiceNumberError] = useState("");
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-CA');
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const [data, setData] = useState({
    customer_name: "",
    invoice_number: "",
    order_number: "",
    invoice_date: "",
    terms: "",
    due_date: "",
    po_number: "",
    sales_person_name: "",
    customer_id: "",
    sales_person_id: "",
    invoice_no: "",
    order_no: "",
    customer_email: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitType, setSubmitType] = useState("");
  /** When true on publish, email invoice PDF + pay link to customer. */
  const [sendToCustomer, setSendToCustomer] = useState(false);
  /** When true on publish, send invoice/quote summary via WhatsApp (Aisensy). */
  const [sendWhatsAppToCustomer, setSendWhatsAppToCustomer] = useState(false);




  const [items, setItems] = useState([
    { id: 1, item: null, quantity: "", rate: "", discount: "", tax: "" },
  ]);


  const [customerNote, setCustomerNote] = useState("");
  const [shipping, setShipping] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [advance_payment, setAdvancePayment] = useState(0);
  const [itemsOptions, setItemsOptions] = useState([]);
  const url = API_BASE_URL
  const token = decryptToken("accessToken") || ""

  const [totals, setTotals] = useState({
    subtotal: 0,
    discount_amount: 0,
    advance_payment: 0,
    pending: 0,
    tax: 0,
    shipping: 0,
    grand_total: 0
  });


  const updateDueDate = (startDate, terms) => {
    if (!startDate || !terms) {
      setData(prev => ({ ...prev, due_date: "" }));
      return;
    }

    const date = new Date(startDate);
    let daysToAdd = 0;

    switch (terms) {
      case '15-net': daysToAdd = 15; break;
      case '30-net': daysToAdd = 30; break;
      case '45-net': daysToAdd = 45; break;
      case '60-net': daysToAdd = 60; break;
      case 'end-month':
        date.setMonth(date.getMonth() + 1);
        date.setDate(0);
        setData(prev => ({ ...prev, due_date: date.toISOString().split('T')[0] }));
        return;
      case 'next-month':
        date.setMonth(date.getMonth() + 2);
        date.setDate(0);
        setData(prev => ({ ...prev, due_date: date.toISOString().split('T')[0] }));
        return;
      default: daysToAdd = 0;

    }

    date.setDate(date.getDate() + daysToAdd);
    setData(prev => ({ ...prev, due_date: date.toISOString().split('T')[0] }));
  };

  const [customers, setCustomers] = useState([]);

  /** Stable key for API + invoice row (cust_ID preferred, else DB id). */
  const getCustomerRowKey = (c) => {
    if (!c) return "";
    const cid = c.cust_ID != null ? String(c.cust_ID).trim() : "";
    if (cid) return cid;
    return c.id != null ? String(c.id) : "";
  };

  /** Name stored on invoice (PDF, DB) — without ECC suffix. */
  const customerBaseName = (c) =>
    c?.displayName || c?.companyName || c?.customerName || getCustomerRowKey(c) || "";

  /** Dropdown label: "Customer Name - ECC123". */
  const customerSelectLabel = (c) => {
    const name = customerBaseName(c);
    const key = getCustomerRowKey(c);
    if (name && key && name !== key) return `${name} - ${key}`;
    return name || key || "";
  };

  /** First email on customer record (top-level or contact persons). */
  const getCustomerEmail = (c) => {
    if (!c) return "";
    if (c.email && String(c.email).trim().includes("@")) return String(c.email).trim();
    let contacts = c.contact;
    if (typeof contacts === "string") {
      try {
        contacts = JSON.parse(contacts);
      } catch {
        contacts = [];
      }
    }
    if (Array.isArray(contacts)) {
      for (const row of contacts) {
        if (row?.email && String(row.email).trim().includes("@")) {
          return String(row.email).trim();
        }
      }
    }
    return "";
  };

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${url}/api/customer/all/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await response.json();
      // const parsedCustomers = data.customers.map((customer) => ({
      //   ...customer,
      //   billingAddress: customer.billingAddress ? JSON.parse(customer.billingAddress) : {},
      //   shippingAddress: customer.shippingAddress ? JSON.parse(customer.shippingAddress) : {},
      //   contact: customer.contact ? JSON.parse(customer.contact) : [],
      // }));
      setCustomers(data.reverse());
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };


  // Close the modal
  const handleModalClose = () => {
    setModalOpen(false);
  };

  // Handle input change in the modal form
  const handleSalesPersonInputChange = (event) => {
    const { name, value } = event.target;
    setNewSalesPerson({ ...newSalesPerson, [name]: value });
  };

  // Submit the new sales person to the list
  const handleAddSalesPersonSubmit = () => {
    if (newSalesPerson.name && newSalesPerson.email) {
      setSalesPersons([...salesPersons, newSalesPerson]);
      setModalOpen(false); // Close the modal after adding
      setNewSalesPerson({ name: '', email: '' }); // Reset the form
    } else {
      alert('Please fill in both fields!');
    }
  }

  // const fetchStaffNameId = async () => {
  //   try {
  //     const response = await fetch(`${url}/staffregister/allget/${isLoggedIn.main_id}`);
  //     const res = await response.json();

  //     // Assuming response is like: [{ id: 1, employee_name: "Ashish" }, ...]
  //     setStaffList(res);
  //   } catch (error) {
  //     console.error('Error fetching staff:', error);
  //   }
  // };

  const lineHasProduct = (row) => {
    if (!row?.item) return false;
    if (typeof row.item === "object") {
      return Boolean(row.item.title || row.item.label);
    }
    return String(row.item).trim().length > 0;
  };

  const getBillableLineItems = (rows) =>
    rows.filter((row) => {
      const qty = parseFloat(row.quantity) || 0;
      const rate = parseFloat(row.rate) || 0;
      return lineHasProduct(row) && qty > 0 && rate > 0;
    });

  const validateBeforeSave = (dpStatus) => {
    if (!data.customer_id && !String(data.customer_name || "").trim()) {
      toast.error("Please select a customer.");
      return false;
    }

    const billableLines = getBillableLineItems(items);
    if (billableLines.length === 0) {
      toast.error(
        "Add at least one item with quantity and rate. Invoices cannot be saved without line items."
      );
      return false;
    }

    if (dpStatus === "Published" && (Number(totals.grand_total) || 0) <= 0) {
      toast.error("Invoice total must be greater than zero before you submit.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e, dpStatus = "Published") => {
    e.preventDefault();

    if (isSubmitting) return; // prevent double click

    if (!validateBeforeSave(dpStatus)) return;

    const billableLines = getBillableLineItems(items);

    setIsSubmitting(true);
    setSubmitType(dpStatus);

    const isEditing = !!editInvoice;
    const endpoint = isEditing
      ? `${url}/newinvoice/update/${editInvoice.order_number}/${isLoggedIn.main_id}`
      : `${url}/newinvoice`;


    const method = isEditing ? "PUT" : "POST";

    const payload = {
      ...data,
      invoice_number: `${invoicePrefix}${invoiceNumberNumeric}`,
      document_type: isQuoteMode ? "quote" : "invoice",
      created_by: "admin",
      dpstatus: dpStatus,
      customer_note: customerNote,
      items: billableLines.map(row => ({
        id: row.id,
        item: row.item, // full object
        hsn: row.hsn,
        quantity: row.quantity,
        rate: row.rate,
        discount: row.discount,
        tax: row.tax,
        amount: (
          (row.quantity || 0) *
          (row.rate || 0) *
          (1 - (row.discount || 0) / 100) *
          (1 + (row.tax || 0) / 100)
        ).toFixed(2),
      })),
      subtotal: totals.subtotal,
      discount_amount: totals.discount_amount,
      advance_payment: totals.advance_payment,
      pending: totals.pending,
      tax: totals.tax,
      shipping: totals.shipping,
      grand_total: totals.grand_total,
      user_id: isLoggedIn.main_id,
      user_name: isLoggedIn.full_name,
      send_mail: dpStatus === "Published" && sendToCustomer,
      send_whatsapp: dpStatus === "Published" && sendWhatsAppToCustomer,
      customer_email: data.customer_email || "",
    };

    try {
      const res = await fetch(endpoint, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
      });

      const result = await res.json();

      if (!res.ok) {
        const msg = result.message || "";
        if (
          msg.includes("Invoice number already exists") ||
          msg.includes("Order number already exists") ||
          msg.includes("Duplicate invoice or order number")
        ) {
          toast.error(msg || "Save failed due to a duplicate number.");
          if (msg.includes("Order number")) {
            setInvoiceNumberError("");
          } else {
            setInvoiceNumberError(msg || "Invoice number already exists. Please use a unique one.");
          }
        } else {
          toast.error(msg || "Something went wrong. Please try again.");
        }
        return;
      }

      showInvoiceSubmitToast({ dpStatus, isEditing, result, isQuoteMode });
      navigate(isQuoteMode ? "/quotes" : "/invoice");

    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Error submitting invoice. Please check your connection and try again.");
    } finally {
      setIsSubmitting(false);
      setSubmitType("");
    }
  };


  const handleChange = (e, actionMeta) => {
    if (actionMeta) {
      const { name } = actionMeta;
      const value = e?.value || "";

      setData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (name === "customer_name" && value === "new-customer") {
        navigate("/add-customer");
      }

      if (name === "terms") {
        if (value === "custom") {
          // Let the user set the date manually — don't update
          return;
        }

        if (data.invoice_date) {
          updateDueDate(data.invoice_date, value);
        }
      }

      if (name === "sales_person_name" && value === "add-new-salesperson") {
        setModalOpen(true);
      }

    } else {
      const { name, value } = e.target;
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (name === "invoice_date" && data.terms) {
        updateDueDate(value, data.terms);
      }
    }
  };

  useEffect(() => {
    if (!isEditByRoute || location.state?.invoice) return;
    if (!routeEditId) return;

    let cancelled = false;
    const loadInvoiceById = async () => {
      setLoadingRouteInvoice(true);
      try {
        const res = await fetch(`${url}/newinvoice/singleinvoice/${routeEditId}`, {
          headers: authHeaders(token),
        });
        const data = await res.json();
        if (cancelled) return;
        if (!res.ok) {
          toast.error(data.message || "Invoice not found");
          navigate("/invoice");
          return;
        }
        const docType = String(data.document_type || "").toLowerCase();
        if (docType === "credit_note") {
          navigate(`/invoice-detail/${data.id}`, { replace: true });
          return;
        }
        setRouteInvoice(data);
      } catch {
        if (!cancelled) {
          toast.error("Could not load invoice");
          navigate("/invoice");
        }
      } finally {
        if (!cancelled) setLoadingRouteInvoice(false);
      }
    };

    loadInvoiceById();
    return () => {
      cancelled = true;
    };
  }, [routeEditId, isEditByRoute, location.state?.invoice, navigate, token, url]);

  useEffect(() => {
    if (loadingRouteInvoice) return;
    if (isEditByRoute && routeEditId && !editInvoice) return;

    const fetchInitialData = async () => {
      if (editInvoice) {
        const {
          invoice_number,
          order_number,
          invoice_date,
          terms,
          due_date,
          po_number,
          sales_person_name,
          customer_name,
          items,
          customer_note,
          shipping,
          advance_payment,
          customer_id,
          sales_person_id
        } = editInvoice;

        setData({
          customer_name,
          invoice_number,
          order_number,
          invoice_date,
          terms,
          due_date,
          po_number: po_number || "",
          sales_person_name,
          customer_id,
          sales_person_id
        });
        setCustomerNote(customer_note || "");
        fetchDataProfile(customer_note || "");

        setInvoiceNumberNumeric(invoice_number.replace(/^(INVE|QUO)/, ""));

        // ✅ Robust parsing logic
        let parsedItems = [];

        try {
          if (typeof items === "string") {

            let firstParse = JSON.parse(items);

            if (typeof firstParse === "string") {
              firstParse = JSON.parse(firstParse);
            }

            if (Array.isArray(firstParse)) {
              parsedItems = firstParse;
            } else {
              throw new Error("Parsed 'items' is not an array");
            }

          } else if (Array.isArray(items)) {
            parsedItems = items;
          } else {
            throw new Error("Invalid format: 'items' must be an array or JSON string");
          }
        } catch (err) {
          console.error("Invalid items format:", err);
          parsedItems = [];
        }

        if (Array.isArray(parsedItems)) {
          const hydratedItems = parsedItems.map(row => {
            if (row.item && typeof row.item === "object" && !row.item.id) {
              const matched = itemsOptions.find(opt =>
                opt.value.title === row.item.title
              );
              return {
                ...row,
                item: matched?.value || row.item
              };
            }
            return row;
          });

          setItems(hydratedItems);
          // setItems(hydratedItems);
        } else {
          console.error("Parsed items is not an array:", parsedItems);
          setItems([]);
        }






        setShipping(shipping || 0);
        setAdvancePayment(advance_payment || 0);


      } else {
        // Normal fresh create mode
        const numberPath = isQuoteMode
          ? `${url}/newinvoice/next-quote-number/${isLoggedIn.main_id}`
          : `${url}/newinvoice/next-number/${isLoggedIn.main_id}`;
        const [invoiceRes, orderRes] = await Promise.all([
          fetch(numberPath, {
            headers: authHeaders(token),
          }),
          fetch(`${url}/newinvoice/next-order-number/${isLoggedIn.main_id}`, {
            headers: authHeaders(token),
          }),
        ]);
        const invoiceData = await invoiceRes.json();
        const orderData = await orderRes.json();
        const today = new Date().toLocaleDateString('en-CA');

        setInvoiceNumberNumeric(invoiceData.invoice_number.replace(/^(INVE|QUO)/, ""));
        setData((prev) => ({
          ...prev,
          invoice_number: invoiceData.invoice_number,
          order_number: orderData.order_number,
          invoice_date: today
        }));
      }
    };

    fetchInitialData();
  }, [editInvoice?.id, loadingRouteInvoice, isEditByRoute, routeEditId]);

  const fetchDataProfile = async (existingNote) => {
    const strippedNote = existingNote?.replace(/<\/?[^>]+(>|$)/g, "").trim();
    if (strippedNote) {
      return;
    }

    try {
      const profileRes = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const res = await profileRes.json();
      const profileData = res.users;
      setCustomerNote(profileData.custom_note || "");
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!editInvoice && customerNote === "") {
      fetchDataProfile();
    }
  }, [editInvoice, customerNote]);

  useEffect(() => {
    fetchCustomers();
  }, []);

  if (loadingRouteInvoice) {
    return <Loader />;
  }

  return (
    <div className="product-form-page product-form-page--invoice">
      <div className="oms-header product-form-page__header">
        <div className="product-form-page__title-wrap">
          <h1 className="dashboard-title">
            {editInvoice
              ? isQuoteMode
                ? "Edit quote"
                : "Edit Invoice"
              : isQuoteMode
                ? "New quote"
                : "New Invoice"}
          </h1>
          <p className="product-form-page__subtitle">
            {editInvoice
              ? isQuoteMode
                ? "Update line items and send the estimate to your customer. Convert to invoice when they approve."
                : "Update line items, totals, and customer details. Published invoices can be resent to the customer."
              : isQuoteMode
                ? "Create a quote or proforma for the customer. Convert it to an invoice once approved."
                : "Fill in customer and billing details, add products or services, then save as draft or publish."}
          </p>
        </div>
        <div className="product-form-page__header-actions">
          <button
            type="button"
            className="product-form-page__back"
            onClick={() => navigate(isQuoteMode ? "/quotes" : "/invoice")}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="omsnewbutton-copy"
            onClick={(e) => handleSubmit(e, "Draft")}
            disabled={isSubmitting}
          >
            {isSubmitting && submitType === "Draft" ? "Saving…" : "Save draft"}
          </button>
          <button
            type="button"
            className="oms-add-btn"
            onClick={(e) => handleSubmit(e, "Published")}
            disabled={isSubmitting}
          >
            {isSubmitting && submitType === "Published"
              ? isQuoteMode
                ? "Sending…"
                : "Publishing…"
              : editInvoice
                ? "Update"
                : isQuoteMode
                  ? "Send quote"
                  : "Publish"}
          </button>
        </div>
      </div>

      <form className="oms-modal-form property-form product-form-page__form" onSubmit={(e) => e.preventDefault()}>
        <div className="oms-givepaddingfrom">
          <div className="product-form-page__section">
            <h2 className="product-form-page__section-title">Invoice details</h2>
            <p className="product-form-page__section-desc">
              Customer, invoice number, dates, and payment terms.
            </p>
          </div>

          <div className="oms-form-flex product-form-page__invoice-grid">
          <div className="oms-form-group">
            <label htmlFor="name" className="oms-form-label">Customer Name</label>
            <Select
              name="customer_name"
              value={(() => {
                if (!data.customer_id && !data.customer_name) return null;
                const byKey = customers.find(
                  (c) => getCustomerRowKey(c) === String(data.customer_id || "").trim()
                );
                if (byKey) {
                  return {
                    value: getCustomerRowKey(byKey),
                    label: customerSelectLabel(byKey),
                  };
                }
                const id = String(data.customer_id || "").trim();
                const nm = String(data.customer_name || "").trim();
                return {
                  value: id || nm,
                  label: nm && id && nm !== id ? `${nm} - ${id}` : nm || id || "",
                };
              })()}
              onChange={(e) => {
                if (!e) {
                  setData((prev) => ({
                    ...prev,
                    customer_name: "",
                    customer_id: "",
                    customer_email: "",
                  }));
                  return;
                }
                if (e.value === "new-customer") {
                  navigate("/add-customer");
                  return;
                }
                const selectedCustomer = customers.find(
                  (c) => getCustomerRowKey(c) === String(e.value)
                );
                setData((prev) => ({
                  ...prev,
                  customer_name: selectedCustomer
                    ? customerBaseName(selectedCustomer)
                    : String(e.value),
                  customer_id: selectedCustomer
                    ? getCustomerRowKey(selectedCustomer)
                    : String(e.value),
                  customer_email: selectedCustomer ? getCustomerEmail(selectedCustomer) : "",
                }));
              }}
              options={[
                ...customers
                  .filter((c) => getCustomerRowKey(c))
                  .map((c) => ({
                    value: getCustomerRowKey(c),
                    label: customerSelectLabel(c),
                  })),
                { value: "new-customer", label: "Add New Customer" },
              ]}
              placeholder="Select Customer Name"
            />



          </div>
          {/* {console.log(data.customer_id)} */}
          <div className="oms-form-group">
            <label htmlFor="customer_id" className="oms-form-label">Customer ID</label>
            <input
              type="text"
              name="customer_id"
              value={data.customer_id}
              readOnly
            />

          </div>



          <div className="oms-form-group">
            <label htmlFor="invoice_number" className="oms-form-label">Invoice Number</label>
            <div className="product-form-page__invoice-prefix">
              <span className="product-form-page__invoice-prefix-tag">{invoicePrefix}</span>
              <input
                type="text"
                name="invoice_number"
                className="product-form-page__invoice-prefix-input"
                value={invoiceNumberNumeric}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setInvoiceNumberNumeric(value);
                }}
                placeholder="00001"
                disabled={editInvoice}
              />
            </div>
            {invoiceNumberError && (
              <span className="product-form-page__field-hint product-form-page__field-hint--error">
                {invoiceNumberError}
              </span>
            )}
          </div>


          <div className="oms-form-group">
            <label htmlFor="order-number" className="oms-form-label">Order number</label>
            <input type="number" name="order_number" value={data.order_number} onChange={handleChange} readOnly />
          </div>

          <div className="oms-form-group">
            <label htmlFor="invoice-date" className="oms-form-label">Invoice Date</label>
            <input
              type="date"
              name="invoice_date"
              value={data.invoice_date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="oms-form-group">
            <label htmlFor="terms" className="oms-form-label">Terms</label>
            <Select
              name="terms"
              options={TERMS_OPTIONS.filter((o) => o.value !== '')}
              value={
                data.terms
                  ? TERMS_OPTIONS.find((o) => o.value === data.terms) || {
                      value: data.terms,
                      label: data.terms,
                    }
                  : null
              }
              onChange={handleChange}
              placeholder="Select Terms"
            />
          </div>

          <div className="oms-form-group">
            <label htmlFor="due-date" className="oms-form-label">Due Date</label>
            <input
              type="date"
              name="due_date"
              value={data.due_date}
              onChange={handleChange}
              disabled={data.terms !== "custom"} // disabled unless custom is selected
            />

          </div>

          <div className="oms-form-group">
            <label htmlFor="po_number" className="oms-form-label">P.O. Number</label>
            <input
              type="text"
              name="po_number"
              id="po_number"
              value={data.po_number}
              onChange={handleChange}
              placeholder="e.g. PO-12345 or ABC42"
            />
          </div>

          {/* <div className="oms-form-group">
              <label htmlFor="sale" className="oms-form-label">Sales Person</label>
              <Select
                name="sales_person_name"
                value={
                  selectedStaff
                    ? {
                      value: selectedStaff.emplyee_ID,
                      label: `${selectedStaff.firstName} ${selectedStaff.lastName} - ${selectedStaff.emplyee_ID}`
                    }
                    : null
                }
                onChange={(selectedOption) => {
                  if (selectedOption.value === "add-new-salesperson") {
                    setModalOpen(true);
                    return;
                  }

                  const selectedStaff = staffList.find(s => s.emplyee_ID === selectedOption.value);
                  if (selectedStaff) {
                    setData(prev => ({
                      ...prev,
                      sales_person_name: `${selectedStaff.firstName} ${selectedStaff.lastName}`.trim(),
                      sales_person_id: selectedStaff.emplyee_ID
                    }));
                  }
                }}
                options={[
                  ...staffList.map(staff => ({
                    value: staff.emplyee_ID,
                    label: `${staff.firstName} ${staff.lastName} - ${staff.emplyee_ID}`
                  })),
                  { value: "", label: "Select Sales Person" }
                ]}
                placeholder="Select Sales Person"
              />

            </div>
            <div className="oms-form-group">
              <label htmlFor="sales_person_id" className="oms-form-label">Sales Person ID</label>
              <input type="text" name="sales_person_id" value={data.sales_person_id} onChange={handleChange} />
            </div> */}



          {/* Sales Person Dropdown */}

        </div>

        <div className="product-form-page__section product-form-page__section--items">
          <h2 className="product-form-page__section-title">Line items</h2>
          <p className="product-form-page__section-desc">
            Add products or services, quantities, tax, and discounts.
          </p>
        </div>

        {/* item table */}
        <ItemTable items={items} setItems={setItems} setSubtotal={setSubtotal} itemsOptions={itemsOptions} setItemsOptions={setItemsOptions} />

        <div className="product-form-page__section product-form-page__section--totals">
          <h2 className="product-form-page__section-title">Notes & totals</h2>
          <p className="product-form-page__section-desc">
            Customer note appears on the invoice; review amounts before publishing.
          </p>
        </div>

        <TotalSection
          items={items}
          setShipping={setShipping}
          shipping={shipping}
          customerNote={customerNote}
          setCustomerNote={setCustomerNote}
          setTotals={setTotals}
          advance_payment={advance_payment}
          editInvoice={editInvoice}

          setAdvancePayment={setAdvancePayment}
        />

        <div className="product-form-page__invoice-delivery-opt">
          <label className="product-form-page__invoice-checkbox">
            <input
              type="checkbox"
              checked={sendToCustomer}
              onChange={(e) => setSendToCustomer(e.target.checked)}
            />
            <span>
              {isQuoteMode
                ? "Email quote PDF to customer"
                : "Email invoice and pay link to customer"}
            </span>
          </label>
          <label className="product-form-page__invoice-checkbox" style={{ marginTop: 10 }}>
            <input
              type="checkbox"
              checked={sendWhatsAppToCustomer}
              onChange={(e) => setSendWhatsAppToCustomer(e.target.checked)}
            />
            <span>
              {isQuoteMode
                ? "Send quote via WhatsApp"
                : "Send invoice via WhatsApp (amount due + pay link)"}
            </span>
          </label>
          <p className="product-form-page__field-hint">
            Requires customer mobile (WhatsApp) and/or email on their profile. Server env:
            AISENSY_INVOICE_CAMPAIGN_NAME for WhatsApp; SMTP in Settings for email.
            Leave both unchecked to save only.
          </p>
        </div>

        {/* Modal for adding a new Sales Person */}
        {modalOpen && (
          <div className="sale-person-modal open">
            <div className="sale-person-modal-content">
              <span className="close-btn" onClick={handleModalClose}>
                <i className="fa-solid fa-xmark"></i>
              </span>
              <h3>Add Sales Person</h3>
              <label htmlFor="salesPersonName">Name</label>
              <input
                type="text"
                name="name"
                value={newSalesPerson.name}
                onChange={handleSalesPersonInputChange}
                placeholder="Sales Person Name"
              />
              <label htmlFor="salesPersonEmail">Email</label>
              <input
                type="email"
                name="email"
                value={newSalesPerson.email}
                onChange={handleSalesPersonInputChange}
                placeholder="Sales Person Email"
              />
              <button type="button" onClick={handleAddSalesPersonSubmit}>Add Sales Person</button>
            </div>
          </div>
        )}

        <div className="oms-form-actions product-form-page__invoice-footer">
          <button
            type="button"
            className="product-form-page__back"
            onClick={() => navigate(isQuoteMode ? "/quotes" : "/invoice")}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="omsnewbutton-copy"
            onClick={(e) => handleSubmit(e, "Draft")}
            disabled={isSubmitting}
          >
            {isSubmitting && submitType === "Draft" ? "Saving…" : "Save draft"}
          </button>
          <button
            type="button"
            className="post-property-submit"
            onClick={(e) => handleSubmit(e, "Published")}
            disabled={isSubmitting}
          >
            {isSubmitting && submitType === "Published"
              ? isQuoteMode
                ? "Sending…"
                : "Publishing…"
              : editInvoice
                ? "Update"
                : isQuoteMode
                  ? "Send quote"
                  : "Publish"}
          </button>
        </div>
        </div>
      </form>
    </div>
  );
};

export default NewInvoice;
